import { Menu } from "lucide-react";
import { Button } from "@mira/ui";

interface TopNavProps {
  pageTitle: string;
  onMenuClick?: () => void;
}

export function TopNav({ pageTitle: _pageTitle, onMenuClick }: TopNavProps) {
  return (
    <div className="h-[64px] w-full bg-pure-white/80 dark:bg-dark-card/80 backdrop-blur-md border-b border-stone dark:border-dark-border px-4 flex lg:hidden items-center justify-between gap-4">
      {/* Hamburger */}
      <Button
        variant="icon-ghost"
        size="sm"
        onClick={onMenuClick}
        className="-ml-1 shrink-0"
        aria-label="Open menu"
      >
        <Menu className="w-5 h-5" />
      </Button>

      {/* TWIIN Logo — centred */}
      <div
        className="text-[26px] font-bold tracking-tight text-near-black dark:text-pure-white select-none absolute left-1/2 -translate-x-1/2"
        style={{ fontFamily: "'Oswald', sans-serif" }}
      >
        TWIIN
        <span className="text-near-black dark:text-electric-lime">.</span>
      </div>

      {/* Spacer to balance hamburger */}
      <div className="w-8 shrink-0" />
    </div>
  );
}
